import { getJivoUserToken } from "./api/getJivoUserToken";

let jivoRefreshTimer = null;

export function initJivo() {
    if (typeof window === "undefined") return;

    if (document.getElementById("jivo-script")) return;

    const s = document.createElement("script");

    s.src = "//code.jivo.ru/widget/33BzTTrwQ7";
    s.async = true;
    s.id = "jivo-script";

    if (document.head) document.head.appendChild(s);
    else document.body.appendChild(s);
}

export function openJivo() {
    try {
        if (window.jivo_api && typeof window.jivo_api.open === "function") {
            window.jivo_api.open();
        } else {
            const s = document.getElementById("jivo-script");

            if (s) {
                s.addEventListener(
                    "load",
                    () => {
                        if (
                            window.jivo_api &&
                            typeof window.jivo_api.open === "function"
                        ) {
                            window.jivo_api.open();
                        }
                    },
                    { once: true }
                );
            }
        }
    } catch (e) {
        console.warn("Jivo open failed", e);
    }
}

export function setJivoToken(token) {
    const apply = () => {
        if (
            window.jivo_api &&
            typeof window.jivo_api.setUserToken === "function"
        ) {
            window.jivo_api.setUserToken(token);
        }
    };

    if (window.jivo_api && typeof window.jivo_api.setUserToken === "function") {
        apply();
    } else {
        document
            .getElementById("jivo-script")
            ?.addEventListener("load", apply, { once: true });
    }
}

export function setJivoContactInfo({ name, email, phone, description } = {}) {
    if (
        typeof window !== "undefined" &&
        window.jivo_api &&
        typeof window.jivo_api.setContactInfo === "function"
    ) {
        try {
            window.jivo_api.setContactInfo({ name, email, phone, description });
        } catch (e) {
            void e;
        }
    }
}

export function clearJivoToken() {
    try {
        if (
            window.jivo_api &&
            typeof window.jivo_api.setUserToken === "function"
        ) {
            window.jivo_api.setUserToken(null);
        }
    } catch (e) {
        console.warn("Failed to clear Jivo token", e);
    }

    if (jivoRefreshTimer) {
        clearTimeout(jivoRefreshTimer);
        jivoRefreshTimer = null;
    }
}

function scheduleJivoRefresh(fetchAndApply, expiresAt) {
    if (!expiresAt) return;

    if (jivoRefreshTimer) clearTimeout(jivoRefreshTimer);

    const now = Math.floor(Date.now() / 1000);
    const secondsLeft = Math.max(expiresAt - now, 0);
    const refreshInMs = Math.max((secondsLeft - 60) * 1000, 15000); // ~1 min before expiry

    jivoRefreshTimer = setTimeout(fetchAndApply, refreshInMs);
}

/**
 * Connects Jivo user token lifecycle to your auth state.
 * - isAuthorizedRef: Vue ref<boolean> that indicates when user is authorized.
 */
export function setupJivoUserToken({ isAuthorizedRef }) {
    async function fetchAndApplyJivoToken() {
        try {
            const data = await getJivoUserToken();
            const { token, expiresAtUnix } = data || {};

            if (token) {
                setJivoToken(token);

                // Apply contact info to Jivo operator view
                const { name, email, phone, description } = data || {};

                setJivoContactInfo({ name, email, phone, description });

                if (typeof expiresAtUnix === "number") {
                    scheduleJivoRefresh(fetchAndApplyJivoToken, expiresAtUnix);
                }
            }
        } catch (e) {
            console.warn("Failed to fetch/apply Jivo token", e);
        }
    }

    if (isAuthorizedRef.value) {
        fetchAndApplyJivoToken();
    } else {
        clearJivoToken();
    }

    return {
        fetchAndApplyJivoToken,
    };
}
